<script lang="ts" setup>
import { HttpStatusCode } from '@/api/results'

import ErrorNotFound from '@/components/Error/NotFound.vue'
import ErrorSomethingWrong from '@/components/Error/SomethingWrong.vue'

import type { NuxtError } from '#app'

type Props = { error: NuxtError }

const props = defineProps<Props>()

const errorComponent = computed(() =>
  Number(props.error?.statusCode) === HttpStatusCode.NOT_FOUND
    ? ErrorNotFound
    : ErrorSomethingWrong,
)

const { isDesktop } = useDevice()

const layout = isDesktop ? 'default' : 'mobile'
</script>

<template>
  <app-root>
    <NuxtLayout :name="layout">
      <component :is="errorComponent" />
    </NuxtLayout>
  </app-root>
</template>
